import { render, staticRenderFns } from "./ABigScreemTop.vue?vue&type=template&id=73750521&"
import script from "./ABigScreemTop.vue?vue&type=script&lang=js&"
export * from "./ABigScreemTop.vue?vue&type=script&lang=js&"
import style0 from "./ABigScreemTop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports